module.exports = __webpack_public_path__ + "img/DOLLAR_SIGN.834c8925.svg";